module.exports = __webpack_public_path__ + "img/2024-12-12d_2.55b84920.jpg";